/**
 * 页面标题栏组件：标题 + 副标题 + 右侧操作区。
 *
 * @module components/common/PageHeader
 */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

/** PageHeader 属性。 */
export interface PageHeaderProps {
  /** 标题。 */
  title: string;
  /** 副标题（可选）。 */
  subtitle?: string;
  /** 右侧操作区（按钮等）。 */
  action?: ReactNode;
}

/**
 * 页面标题栏。
 *
 * @param props 组件属性。
 * @returns JSX 元素。
 */
export default function PageHeader({
  title,
  subtitle,
  action,
}: PageHeaderProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        mb: 3,
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box>
        <Typography variant="h5" fontWeight={700}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && <Box>{action}</Box>}
    </Box>
  );
}
